<template>
    <div>
        <v-card flat>
            <v-card-title>
                {{ $t('bank_account') }}
                <v-spacer></v-spacer>
                <v-btn 
                    v-if="selected.bankAccounts.length == 1"
                    class="mx-1"
                    icon>
                    <v-icon>mdi-eye</v-icon>
                </v-btn>
                <v-btn 
                    class="mx-1"
                    @click="createdDataFetch"
                    icon>
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-menu
                    offset-y
                    :close-on-content-click="false"
                    >
                    <template v-slot:activator="{on: menu}">
                        <v-tooltip bottom="">
                            <template v-slot:activator="{on: tooltip}">
                                <v-btn
                                    icon
                                    v-on="{...menu, ...tooltip}"
                                    class="mx-1">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("search") }}</span>
                        </v-tooltip>
                    </template>
                    <v-text-field
                        :label="$t('search')"
                        solo
                        v-model="search"
                        autofocus="true"
                        hide-details>
                    </v-text-field>
                </v-menu>
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list width="250" dense>
                        <v-list-item
                            @click="openBankAccountDialog(false)"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-database-plus</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('new_bank_account') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider  v-if="selected.bankAccounts.length == 1"></v-divider>
                        <v-list-item
                            v-if="selected.bankAccounts.length == 1"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-eye</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('show_bank_account') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="selected.bankAccounts.length == 1"
                            @click="openBankAccountDialog(true)"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('edit_bank_account') }}</v-list-item-title>
                        </v-list-item>
                         <v-list-item
                            v-if="selected.bankAccounts.length == 1"
                            @click="openDeleteSingleDialog({target: 'bankAccounts', id: getSelected.id})"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('delete_bank_account') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-text>
                <v-data-table
                    dense
                    v-model="selected.bankAccounts"
                    :loading="loading.data"
                    :options.sync="options"
                    show-select
                    single-select
                    :server-items-length="bankAccountLength"
                    :items="bankAccounts"
                    :headers="header.bankAccount">
                    <template v-slot:[`item.active`]="{ item }">
                        <!-- :style="item.active ? 'color : green': 'color :  red'" -->
                        <v-badge dot :color="item.active ? 'success': 'error'" inline left></v-badge> <span >{{ item.active ? 'Active': 'Inactive' }}</span>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <bank-account-dialog
            v-if="bankAccountProps.display"
            :id="bankAccountProps.id"
            @update="createdDataFetch"
            @close="closeBankAccountDialog">
        </bank-account-dialog>
        <retry-dialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit">
        </retry-dialog>
        <delete-single-dialog
            @submit="onDeleteDialogSubmit"
            ref="deleteSingleDialog">

        </delete-single-dialog>
    </div>
</template>

<script>
import BankAccountDialog from '@/components/accounting/BankAccountDialog';
import service from '@/services/service';
import RetryDialog from '../../components/common/RetryDialog.vue';
import { mapActions } from 'vuex';
import DeleteSingleDialog from '../../components/common/DeleteSingleDialog.vue';
export default {
    name: 'BankAccounts',
    components: {
        BankAccountDialog,
        RetryDialog,
        DeleteSingleDialog
    },
    data() {
        return {
            search: null,
            selected: {
                bankAccounts: []
            },
            loading: {
                data: false
            },
            bankAccounts: [],
            bankAccountLength: 0,
            header: {
                bankAccount: [
                    { text: this.$t('code'), value: 'code' },
                    { text: this.$t('bank_name'), value: 'name' },
                    { text: this.$t('currency'), value: 'currency' },
                    { text: this.$t('type_account'), value: 'bank_account_type' },
                    { text: this.$t('state'), value: 'active' },
                ]
            },
            bankAccountProps: {
                id: null,
                display: false
            },
            options: {}
        }
    },
    computed: {
        getSelected() {
            return this.selected.bankAccounts.length == 1 ? this.selected.bankAccounts[0] : {};
        }
    },
    watch: {
        options: {
            handler () {
                this.createdDataFetch()
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('common/snackBar', ["setSnackBars"]),
        async createdDataFetch() {
            try{
                this.loading.data = true;
                let response =  await service('/banking/bank-accounts', 'get', '', {...this.options, ...this.search})
                this.bankAccounts = response.data.data;
                this.bankAccountLength = response.data.total;
                this.loading.data = false;

            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({ target:"createdDataFetch",message });
            }
        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
        openDeleteSingleDialog(params) {
            this.$refs.deleteSingleDialog.open(params);
            this.selected.bankAccounts = [];
        },
        onDeleteDialogSubmit(params) {
            if(params.target == 'bankAccounts') {
              service('/banking/bank-accounts/'+params.id, 'delete')
                    .then(() => {
                        this.$refs.deleteSingleDialog.close();
                        this.createdDataFetch();
                        this.setSnackBars({type: "success", message: this.$t("records_delete_success")});
                    })
                    .catch((error) => {
                        this.$refs.deleteSingleDialog.close();
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({type: "error", message});
                    })
            }
        },

        openBankAccountDialog(editMode) {
            this.bankAccountProps.id =  editMode ? this.getSelected.id : null;
            this.bankAccountProps.display = true;
        },
        closeBankAccountDialog() {
            this.bankAccountProps.display = false;
        }
    },
    created() {
        
    }
}
</script>

<style>

</style>